/* eslint-disable */

import { actions } from 'forms/rrf';
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import {history} from '../store';
import ToastMessage from '../components/common/toast-message';

export const getPages = () => (dispatch) => {
  dispatch({type: 'GET_PAGES_PENDING', payLoad: []});
  return irelandApi
    .get('/api/admin/pages')
    .then((response) => {
      dispatch({type: 'GET_PAGES_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PAGES_REJECTED', payLoad: error.data});
    });
};

export const getPage = id => (dispatch) => {
  dispatch({type: 'GET_PAGE_PENDING', payLoad: []});
  return irelandApi
    .get(`/api/admin/pages/${id}`)
    .then((response) => {
      dispatch({type: 'GET_PAGE_FULFILLED', payLoad: response.data});
      dispatch(actions.change('deep.page', {
        login_required: `${response.data.data.attributes['login-required']}`,
        name: response.data.data.attributes.name,
        page_template: response.data.data.attributes['page-template']
      }));
    })
    .catch((error) => {
      dispatch({type: 'GET_PAGE_REJECTED', payLoad: error.data});
    });
};
export const storePage = (payLoad, id) => irelandApi
  .post('/api/admin/pages', {page: payLoad})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="Page has been saved successfully"/>);
    history.push('/admin/pages');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occured during save"/>);
  });

export const savePage = (payLoad, id) => {
  const link = `/api/admin/pages/${id}`;
  return irelandApi
    .put(link, {page: payLoad})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Page has been saved successfully"/>);
      history.push('/admin/pages');
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during save"/>);
    });
};

export const deletePage = id => dispatch => irelandApi.delete(`/api/admin/pages/${id}`)
  .then((res) => {
    toast.success(<ToastMessage iconStyle="success" message="Page has been deleted successfully"/>);
    dispatch({type: 'DELETE_PAGE_FULFILLED', payLoad: {id}});
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occured during delete page"/>);
    dispatch({type: 'DELETE_PAGE_REJECTED', payLoad: {id}});
    return Promise.reject(error.response.data);
  });

export const getTemplates = () => (dispatch) => {
  dispatch({
    type: 'GET_TEMPLATES_PENDING',
    payLoad: []
  });

  return irelandApi.get('/api/admin/pages/new')
    .then((response) => {
      dispatch({
        type: 'GET_TEMPLATES_FULFILLED',
        payLoad: response.data.meta
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_TEMPLATES_REJECTED',
        payLoad: error.data
      });
    });
};
